import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckinPopup } from "./CheckinPopup";
import { setScannerCheckinToken } from "../redux/actions/gym/gymAction";
import { FloatingDropUp } from "./FloatingDropUp";
import axios from "axios";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { ExpiringTodayPopUp } from "./expiringTodayPopup";
import CheckinSuccessModal from "./CheckinResponsePopup";

const nonCharacterKeys = ['Shift', 'Control', 'Alt', 'Meta', 'Enter', 'Tab',
  'CapsLock', 'NumLock', 'Backspace', 'Delete', 'Insert',
  'Home', 'End', 'PageUp', 'PageDown', 'ArrowUp', 'ArrowDown',
  'ArrowLeft', 'ArrowRight', 'ContextMenu', 'Escape', 'F1',
  'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10',
  'F11', 'F12', 'Pause', 'ScrollLock'];

export const CheckinScannerHandler = () => {
  const dispatch = useDispatch();
  const checkinStrRef = useRef('');
  const timeoutIdRef = useRef(null);
  const { checkinPopupOpen, scannerCheckinToken, gym } = useSelector(state => state.gym);
  const [checkinData, setCheckinData] = useState(JSON.parse(sessionStorage.getItem('temp-checkin-list')) || [])
  const [changedFlag, setchangedFlag] = useState(false)
  const [scannerMember, setScannerMember] = useState(null);
  console.log('length', checkinData.length)

  const AddToCheckinList = (user) => {
    const prevList = checkinData;
    prevList.unshift(user);
    sessionStorage.setItem('temp-checkin-list', JSON.stringify(prevList));
    setCheckinData(prevList);
    setchangedFlag(!changedFlag)
  }

  useEffect(() => {
    if (scannerCheckinToken)
    axios.post(`${process.env.REACT_APP_SERVER_URL}scannerCheckin`,
      { token: scannerCheckinToken },
      {
        headers: {
          "Content-Type": "application/json",
          "x-auth": JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))?.token,
        }
      }).then(res => {
          const user = {
            name: res.data.data.memberData.name,
            viewed: checkinPopupOpen,
            package: res.data.data.memberhsipUsed.name,
            time: moment(res.data.data.timestamp).format('DD-MM-YYYY hh:mm A'),
            success: true,
            image:res.data.data.memberData.image
          }
          AddToCheckinList(user)
          setScannerMember(user)
          dispatch(setScannerCheckinToken(undefined))
        }).catch((e) => {
          const res = e.response?.data;
          console.error('[ScannerCheckin] API Error:', res?.error || e.message);
          
          if (res?.status === 400) {
            toastr.error(res.error);
            dispatch(setScannerCheckinToken(undefined));
          }
          else {
            toastr.error('Something went wrong, please try scanning again');
            dispatch(setScannerCheckinToken(undefined));
          } 
          if (res?.error === "No Active Membership" || res?.error === "Member not found" ||res?.error==="Member already checked-in Today") {
            const user = {
              name: res.data?.name || 'Unknown',
              viewed: true,
              package: undefined,
              time: moment().format('DD-MM-YYYY hh:mm A'),
              success: false,
              error:res?.error,
              image:res.data.image
            };
            AddToCheckinList(user)
            setScannerMember(user)
            dispatch(setScannerCheckinToken(undefined))
            return;
          }
        })
  }, [scannerCheckinToken])

  useEffect(() => {
    const keyupHandler = (e) => {
      if (timeoutIdRef.current !== null) {
        clearTimeout(timeoutIdRef.current);
      }

      if (!nonCharacterKeys.includes(e.key) && e.code !== 'Space') {
        checkinStrRef.current += e.key;
      }

      if ((checkinStrRef.current.length === 141 && checkinStrRef.current.startsWith('eyJ') || checkinStrRef.current.length === 8 && checkinStrRef.current.startsWith('t-'))) {
        dispatch(setScannerCheckinToken(checkinStrRef.current));
        checkinStrRef.current = '';
        return;
      }

      timeoutIdRef.current = setTimeout(() => {
        checkinStrRef.current = '';
      }, 1000);
    };

    document.addEventListener('keydown', keyupHandler);

    return () => {
      document.removeEventListener('keydown', keyupHandler);
    };

  }, []);

  return (
    <>
      {
       gym?.subscriptionPlan?.id == 1 ?
       <></>
       :
       <>
        <CheckinPopup checkinData={checkinData} setCheckinData={setCheckinData} />
        <ExpiringTodayPopUp />
        <FloatingDropUp checkinData={checkinData} setCheckinData={setCheckinData} />
        <CheckinSuccessModal member={scannerMember} onClose={() => setScannerMember(null)}
        />
       </>
      }
    </>
  );
}
